import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class HomeIaRateLimitService {
  private retryAfterUntil?: number;

  setRetryAfterSeconds(seconds?: number | null): void {
    if (typeof seconds !== "number" || Number.isNaN(seconds) || seconds <= 0) {
      return;
    }
    this.retryAfterUntil = Date.now() + seconds * 1000;
  }

  getDelayMs(): number {
    if (!this.retryAfterUntil) {
      return 0;
    }
    const remaining = this.retryAfterUntil - Date.now();
    return remaining > 0 ? remaining : 0;
  }
}
